import React, { useState } from "react";
import PageContainer from "../common/PageContainer";
import Header from "../common/Header";
import SearchBar from "../common/SearchBar";
import { fetchWithToken } from "../../functions/fetch";
import { sortByTime } from "../../functions/array";
import HistoryList from "./HistoryList";
import { addSearchedField } from "../../functions/history";
import RouteProtection from "../common/RouteProtection";
import { Button, Input, Text } from "@chakra-ui/react";
import { useFormik } from "formik";
import color from "../../config/color";
import { getHistorySchema } from "../../validation/historyValidation";
import ErrorMessages from "../common/PopUp/ChakraFormik/ErrorMessages";
import { DateTime } from "luxon";

export default function HistoryPage() {
  const [unfilteredItems, setUnfilteredItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);

  const fetchHistory = async (startTime, endTime) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_HOST}/api/history?`;
      if (startTime) {
        url += `startTime=${startTime}`;
      }
      if (endTime) {
        url += `&endTime=${endTime}`;
      }

      const res = await fetchWithToken("GET", url);
      if (res.status === 200) {
        const { histories } = res;

        const sortedHistories = sortByTime(histories, "createdAt");
        addSearchedField(histories);

        setUnfilteredItems(sortedHistories);
        setFilteredItems(sortedHistories);
      } else {
        console.error(res);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const formik = useFormik({
    initialValues: {
      startTime: DateTime.now({ zone: "utc+8" }).toFormat("yyyy-MM-dd"),
      endTime: DateTime.now({ zone: "utc+8" }).toFormat("yyyy-MM-dd"),
    },
    validationSchema: getHistorySchema,
    onSubmit: async (values) => {
      const { startTime, endTime } = values;
      await fetchHistory(startTime, endTime);
    },
  });

  return (
    <>
      <Header />
      <RouteProtection />
      <PageContainer>
        <div className="flex justify-between items-center">
          <div className="pt-8 pl-12 flex whitespace-nowrap items-center gap-2">
            <Text>查詢時段：</Text>
            <Input
              type="date"
              variant="filled"
              {...formik.getFieldProps("startTime")}
            />
            <Text>至</Text>
            <Input
              type="date"
              variant="filled"
              {...formik.getFieldProps("endTime")}
            />
            <Button
              colorScheme="orange"
              bgColor={color.orange}
              px={8}
              onClick={formik.handleSubmit}
            >
              查詢
            </Button>
            <ErrorMessages formik={formik} />
          </div>
          <SearchBar items={unfilteredItems} setFunction={setFilteredItems} />
        </div>
        <HistoryList histories={filteredItems} />
      </PageContainer>
    </>
  );
}
